/**
 * Route Definitions
 *
 * Defines all routes for the SPA application
 */

import type { Route } from '@/types';

// Import all view classes
import { HomeView } from '../views/HomeView';
import { ProfileView } from '../views/ProfileView';
import { FinancialsView } from '../views/FinancialsView';
import { IncomeStatementView } from '../views/IncomeStatementView';
import { BalanceSheetView } from '../views/BalanceSheetView';
import { CashFlowView } from '../views/CashFlowView';
import { TimelineView } from '../views/TimelineView';
import { LongDescriptionView } from '../views/LongDescriptionView';
import { ProductsView } from '../views/ProductsView';
import { CompetitorsView } from '../views/CompetitorsView';
import { QuickCompsView } from '../views/QuickCompsView';
import { MATransactionsView } from '../views/MATransactionsView';

/**
 * Application routes
 */
export const routes: Route[] = [
	{
		path: '/',
		component: HomeView,
		title: 'Z&P Zapital IQ - Home',
		meta: {
			bodyData: {},
		},
	},
	{
		path: '/profile',
		component: ProfileView,
		title: 'NVIDIA Corporation (NasdaqGS:NVDA) Profile - Z&P Zapital IQ',
		sidebarItem: 'Profile',
		meta: {
			bodyData: {
				'active-sidebar': 'Profile',
			},
		},
	},
	{
		path: '/financials',
		component: FinancialsView,
		title: 'NVIDIA (NVDA) Financials > Key Stats - Z&P Zapital IQ',
		sidebarItem: 'Key Stats',
		meta: {
			bodyData: {
				'active-sidebar': 'Key Stats',
			},
		},
	},
	{
		path: '/income-statement',
		component: IncomeStatementView,
		title: 'NVIDIA (NVDA) Income Statement - Z&P Zapital IQ',
		sidebarItem: 'Income Statement',
		meta: {
			bodyData: {
				'active-sidebar': 'Income Statement',
			},
		},
	},
	{
		path: '/balance-sheet',
		component: BalanceSheetView,
		title: 'NVIDIA (NVDA) Balance Sheet - Z&P Zapital IQ',
		sidebarItem: 'Balance Sheet',
		meta: {
			bodyData: {
				'active-sidebar': 'Balance Sheet',
			},
		},
	},
	{
		path: '/cash-flow',
		component: CashFlowView,
		title: 'NVIDIA (NVDA) Cash Flow - Z&P Zapital IQ',
		sidebarItem: 'Cash Flow',
		meta: {
			bodyData: {
				'active-sidebar': 'Cash Flow',
			},
		},
	},
	{
		path: '/timeline',
		component: TimelineView,
		title: 'NVIDIA (NVDA) Corporate Timeline - Z&P Zapital IQ',
		sidebarItem: 'Corporate Timeline',
		meta: {
			bodyData: {
				'active-sidebar': 'Corporate Timeline',
			},
		},
	},
	{
		path: '/long-description',
		component: LongDescriptionView,
		title: 'NVIDIA Long Business Description - Z&P Zapital IQ',
		sidebarItem: 'Long Business Description',
		meta: {
			bodyData: {
				'active-sidebar': 'Long Business Description',
			},
		},
	},
	{
		path: '/products',
		component: ProductsView,
		title: 'NVIDIA Products - Z&P Zapital IQ',
		sidebarItem: 'Products',
		meta: {
			bodyData: {
				'active-sidebar': 'Products',
			},
		},
	},
	{
		path: '/competitors',
		component: CompetitorsView,
		title: 'NVIDIA Competitors - Z&P Zapital IQ',
		sidebarItem: 'Competitors',
		meta: {
			bodyData: {
				'active-sidebar': 'Competitors',
			},
		},
	},
	{
		path: '/quick-comps',
		component: QuickCompsView,
		title: 'NVIDIA Corporation Quick Comparable Analysis - Z&P Zapital IQ',
		sidebarItem: 'Quick Comps',
		meta: {
			bodyData: {
				'active-sidebar': 'Quick Comps',
			},
		},
	},
	{
		path: '/ma-transactions',
		component: MATransactionsView,
		title: 'NVIDIA Comparable M&A Transactions - Z&P Zapital IQ',
		sidebarItem: 'Comparable M&A Transactions',
		meta: {
			bodyData: {
				'active-sidebar': 'Comparable M&A Transactions',
			},
		},
	},
];

/**
 * Get route by path
 */
export function getRouteByPath(path: string): Route | undefined {
	return routes.find((route) => route.path === path);
}

/**
 * Get route by sidebar item name
 */
export function getRouteBySidebarItem(itemName: string): Route | undefined {
	return routes.find((route) => route.sidebarItem === itemName);
}
